(() => {
  const root = document.querySelector('.armada-wishlist-page');
  if (!root) return;

  const body = root.querySelector('[data-armada-wishlist]');
  const grid = root.querySelector('[data-armada-wishlist-grid]');
  const emptyEl = root.querySelector('[data-armada-wishlist-empty]');
  const shareBtn = root.querySelector('[data-wishlist-share]');
  const subtitleEl = root.querySelector('.armada-wishlist-page__subtitle');
  const swishHost = root.querySelector('[data-armada-wishlist-source]');
  const cardView = body?.dataset.cardView || 'wishlist-card';
  const titleLabelEl = root.querySelector('[data-wishlist-title-label]');
  const countEl = root.querySelector('[data-wishlist-count]');

  const SHARED_PATH_PREFIX = '/pages/wishlist/';

  const urlLooksShared = () => {
    const pathname = window.location.pathname.toLowerCase();
    if (pathname.startsWith(SHARED_PATH_PREFIX)) {
      const slug = pathname.slice(SHARED_PATH_PREFIX.length).split('/')[0];
      if (slug) return true;
    }

    const params = new URLSearchParams(window.location.search);
    for (const key of ['wishlist', 'list_id', 'id', 'token']) {
      const val = params.get(key);
      if (val && val !== 'mine') return true;
    }
    return false;
  };

  const isSharedView = urlLooksShared();
  const titleEl = root.querySelector('.armada-wishlist-page__title');
  const originalTitle = titleLabelEl
    ? titleLabelEl.textContent.trim()
    : titleEl
      ? titleEl.textContent.trim()
      : '';
  const sharedTitle =
    (body && body.dataset.sharedTitle && body.dataset.sharedTitle.trim()) ||
    originalTitle;

  const setTitleLabel = (text) => {
    if (titleLabelEl) {
      titleLabelEl.textContent = text;
    } else if (titleEl) {
      titleEl.textContent = text;
    }
  };

  const updateTitleCount = (count) => {
    if (!countEl) return;
    const safeCount = Number.isFinite(count) && count >= 0 ? count : 0;
    countEl.textContent = `(${safeCount})`;
    countEl.hidden = false;
  };

  const applySharedView = () => {
    root.classList.toggle('is-shared-view', isSharedView);
    if (isSharedView) {
      if (subtitleEl) subtitleEl.hidden = true;
      setTitleLabel(sharedTitle);
    } else {
      setTitleLabel(originalTitle);
    }
  };
  applySharedView();

  const findSwishShareEl = () => {
    if (!swishHost) return null;

    const selectors = [
      'share-button',
      'wishlist-share-button',
      'wk-share-button',
      'wk-button[icon="share"]',
      '[data-action="share"]',
      '[data-wk-action="share"]',
      '.wk-share-button',
      '.wk-controls share-button',
      '.wk-controls .wk-share',
    ];

    for (const sel of selectors) {
      const el = swishHost.querySelector(sel);
      if (el) return el;
    }

    const shareIcon = swishHost.querySelector(
      'wk-icon[icon="share"], .wk-icon[icon="share"], [icon="share"]'
    );
    if (shareIcon) {
      return shareIcon.closest('button, [role="button"], a') || shareIcon;
    }

    const candidates = swishHost.querySelectorAll(
      'button, [role="button"], a[href]'
    );
    for (const el of candidates) {
      const label = (
        el.getAttribute('aria-label') ||
        el.getAttribute('title') ||
        el.textContent ||
        ''
      ).toLowerCase();
      if (label.includes('share')) return el;
    }

    return null;
  };

  const triggerSwishShare = () => {
    const el = findSwishShareEl();
    if (!el) return false;

    const clickable = el.matches('button, [role="button"], a')
      ? el
      : el.querySelector('button, [role="button"], a') || el;

    try {
      clickable.click();
      return true;
    } catch {
      return false;
    }
  };

  let copiedTimer = null;
  const flashCopied = () => {
    if (!shareBtn) return;
    shareBtn.classList.add('is-copied');
    clearTimeout(copiedTimer);
    copiedTimer = setTimeout(() => {
      shareBtn.classList.remove('is-copied');
    }, 2000);
  };

  const copyToClipboard = async (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch {}
    }
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    document.body.removeChild(ta);
    return ok;
  };

  let sharePoll = null;

  const handleShare = async () => {
    if (isSharedView) {
      try {
        const ok = await copyToClipboard(window.location.href);
        if (ok) flashCopied();
      } catch (err) {
        console.error('[wishlist] failed to copy shared URL', err);
      }
      return;
    }

    if (triggerSwishShare()) {
      flashCopied();
      return;
    }

    if (sharePoll) clearInterval(sharePoll);

    let attempts = 0;
    sharePoll = setInterval(() => {
      attempts += 1;
      if (triggerSwishShare()) {
        clearInterval(sharePoll);
        sharePoll = null;
        flashCopied();
      } else if (attempts > 20) {
        clearInterval(sharePoll);
        sharePoll = null;
      }
    }, 100);
  };

  if (shareBtn) {
    shareBtn.addEventListener('click', () => handleShare());
  }

  if (!body || !grid || !swishHost) return;

  const HANDLES_KEY = '__armadaWishlistHandlesHint';
  const COUNT_KEY = '__armadaWishlistCountHint';

  const tilesByHandle = new Map();
  const pendingRemovalHandles = new Set();
  let renderToken = 0;
  let hasHydrated = false;
  let revealed = false;
  let emptyStateTimer = null;

  const EMPTY_DEFER_NO_CACHE_MS = 1200;
  const EMPTY_DEFER_WITH_CACHE_MS = 5000;

  const cancelEmptyStateTimer = () => {
    if (emptyStateTimer) {
      clearTimeout(emptyStateTimer);
      emptyStateTimer = null;
    }
  };

  const detectHydration = () =>
    !!swishHost.querySelector('wishlist-product-card');

  const reveal = () => {
    if (revealed) return;
    revealed = true;
    root.classList.remove('is-loading');
    body.classList.remove('is-loading');
    body.classList.add('is-ready');
  };

  const SKELETON_DEFAULT = 4;
  const SKELETON_MIN = 3;
  const SKELETON_MAX = 12;

  const readCachedCount = () => {
    try {
      const raw = localStorage.getItem(COUNT_KEY);
      if (raw == null) return null;
      const n = parseInt(raw, 10);
      return Number.isFinite(n) && n >= 0 ? n : null;
    } catch {
      return null;
    }
  };

  const buildSkeletonCell = () => {
    const li = document.createElement('li');
    li.className =
      'armada-wishlist-page__cell armada-wishlist-page__cell--skeleton';
    li.setAttribute('aria-hidden', 'true');
    li.innerHTML = `
      <div class="armada-wishlist-skeleton">
        <div class="armada-wishlist-skeleton__media"></div>
        <div class="armada-wishlist-skeleton__lines">
          <div class="armada-wishlist-skeleton__line armada-wishlist-skeleton__line--title"></div>
          <div class="armada-wishlist-skeleton__line armada-wishlist-skeleton__line--price"></div>
        </div>
      </div>
    `;
    return li;
  };

  const renderSkeletons = () => {
    const cached = readCachedCount();
    const count = Math.max(
      SKELETON_MIN,
      Math.min(SKELETON_MAX, cached || SKELETON_DEFAULT)
    );
    const frag = document.createDocumentFragment();
    for (let i = 0; i < count; i++) frag.appendChild(buildSkeletonCell());
    grid.replaceChildren(frag);
    grid.hidden = false;
    if (emptyEl) emptyEl.hidden = true;
  };

  const hasPrerenderedSkeletons = !!grid.querySelector(
    '.armada-wishlist-page__cell--skeleton'
  );
  if (!hasPrerenderedSkeletons) {
    renderSkeletons();
  } else {
    grid.hidden = false;
    if (emptyEl) emptyEl.hidden = true;
  }

  const syncNavCount = (count) => {
    try {
      localStorage.setItem(COUNT_KEY, String(Math.max(0, count)));
    } catch {}
    // AAS-4682: keep the icon's visibility in step when the wishlist page is
    // the thing changing the count (e.g. removing the last item here).
    document.documentElement.classList.toggle('wishlist-has-items', count > 0);
    document.querySelectorAll('[data-wishlist-nav]').forEach((el) => {
      el.classList.toggle('is-wishlisted', count > 0);
      el.dataset.wishlistCount = String(count);
    });
  };

  const writeCachedHandles = (entries) => {
    try {
      localStorage.setItem(HANDLES_KEY, JSON.stringify(entries.slice(0, 100)));
    } catch {}
  };

  const syncWishlistHints = (items) => {
    syncNavCount(items.length);
    writeCachedHandles(
      items.map((item) => ({ handle: item.handle, variantId: item.variantId || '' }))
    );
  };

  const extractHandle = (link) => {
    if (!link) return null;
    const href = link.getAttribute('href') || '';
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  };

  const collectItems = () => {
    const items = [];
    swishHost.querySelectorAll('wishlist-product-card').forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      const handle = extractHandle(link);
      if (!handle) return;
      if (pendingRemovalHandles.has(handle)) return;

      const variantInput = card.querySelector('input[name="id"]');
      items.push({ handle, variantId: variantInput?.value || '', sourceCard: card });
    });
    return items;
  };

  const updateEmptyState = (itemsCount) => {
    if (itemsCount > 0) {
      grid.hidden = false;
      if (emptyEl) emptyEl.hidden = true;
    } else {
      grid.hidden = true;
      if (emptyEl) emptyEl.hidden = isSharedView;
    }

    if (shareBtn) {
      shareBtn.hidden = itemsCount === 0;
    }

    updateTitleCount(itemsCount);
  };

  /* AAS-5630: the market prefix comes from theme.routes, not window.routes —
     the latter is built in snippets/js-variables.liquid and carries only the
     cart and search routes, so root_url read undefined and every tile was
     requested without the prefix. On a localised storefront that is the wrong
     product URL, and no card rendered at all. */
  const productRoot = () => {
    const root = window.theme?.routes?.root_url || window.routes?.root_url || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const fetchTile = async (handle, variantId) => {
    const params = new URLSearchParams({ view: cardView });
    if (variantId) params.set('variant', variantId);

    const url = `${productRoot()}products/${handle}?${params.toString()}`;
    const response = await fetch(url, { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(`wishlist tile fetch failed: ${response.status}`);
    return response.text();
  };

  const REMOVE_VERIFY_INTERVAL_MS = 800;
  const REMOVE_MAX_ATTEMPTS = 4;
  const WISHLIST_TOAST_DURATION_MS = 2000;

  const clickSwishRemove = (sourceCard) => {
    const swishRemove = sourceCard.querySelector(
      'remove-button .wk-button, remove-button button'
    );
    if (!swishRemove) return false;
    try {
      swishRemove.click();
      return true;
    } catch {
      return false;
    }
  };

  const dispatchWishlistToast = (action) => {
    document.dispatchEvent(
      new CustomEvent('armada:wishlist:toast', {
        detail: {
          action,
          duration: WISHLIST_TOAST_DURATION_MS,
        },
      })
    );
  };

  const handleOptimisticRemove = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const removeBtn = event.currentTarget;
    const sourceCard = removeBtn.__armadaWishlistSourceCard;
    if (!sourceCard) return;

    const handle =
      removeBtn.dataset.productHandle ||
      extractHandle(sourceCard.querySelector('a[href*="/products/"]'));
    if (!handle) return;

    pendingRemovalHandles.add(handle);

    const visibleCell = removeBtn.closest('.armada-wishlist-page__cell');
    if (visibleCell) visibleCell.remove();
    tilesByHandle.delete(handle);

    const remainingItems = collectItems();
    updateEmptyState(remainingItems.length);

    if (!isSharedView) {
      syncWishlistHints(remainingItems);
    }

    const removeTriggered = clickSwishRemove(sourceCard);
    if (removeTriggered) {
      dispatchWishlistToast('removed');
    }

    let attempt = 0;
    const verifyRemoval = () => {
      if (!pendingRemovalHandles.has(handle)) return;

      if (!swishHost.contains(sourceCard)) {
        pendingRemovalHandles.delete(handle);
        return;
      }

      attempt += 1;
      if (attempt < REMOVE_MAX_ATTEMPTS) {
        clickSwishRemove(sourceCard);
        setTimeout(verifyRemoval, REMOVE_VERIFY_INTERVAL_MS);
        return;
      }

      pendingRemovalHandles.delete(handle);
      scheduleRender();
    };

    setTimeout(verifyRemoval, REMOVE_VERIFY_INTERVAL_MS);
  };

  const wireRemove = (tile, sourceCard) => {
    const removeBtn = tile.querySelector('[data-armada-wishlist-remove]');
    if (!removeBtn) return;

    removeBtn.__armadaWishlistSourceCard = sourceCard;

    if (removeBtn.__armadaWishlistRemoveBound) return;

    removeBtn.__armadaWishlistRemoveBound = true;
    removeBtn.addEventListener('click', handleOptimisticRemove);
  };

  const stripCardActions = (tile) => {
    tile.querySelectorAll('.product-tile__actions, .product-tile-v2__actions').forEach((node) => node.remove());
  };

  const buildCell = (item, html) => {
    const wrapper = document.createElement('li');
    wrapper.className = 'armada-wishlist-page__cell';
    wrapper.innerHTML = html;

    const tile = wrapper.querySelector('[data-armada-wishlist-card]');
    if (!tile) return null;

    stripCardActions(tile);
    wireRemove(tile, item.sourceCard);

    return wrapper;
  };

  const rebindRemove = (cell, sourceCard) => {
    cell.sourceCard = sourceCard;
    const removeBtn = cell.wrapper.querySelector('[data-armada-wishlist-remove]');
    if (!removeBtn) return;

    wireRemove(cell.wrapper, sourceCard);
  };

  const renderItems = async (items) => {
    if (items.length === 0 && !revealed) {
      if (emptyStateTimer) return;
      const cachedCount = readCachedCount() || 0;
      const delay =
        cachedCount > 0 ? EMPTY_DEFER_WITH_CACHE_MS : EMPTY_DEFER_NO_CACHE_MS;
      emptyStateTimer = setTimeout(() => {
        emptyStateTimer = null;
        const fresh = collectItems();
        if (fresh.length > 0) {
          renderItems(fresh);
          return;
        }
        renderToken += 1;
        grid.replaceChildren();
        tilesByHandle.forEach((cell) => cell.wrapper.remove());
        tilesByHandle.clear();
        updateEmptyState(0);
        if (!isSharedView) syncWishlistHints(fresh);
        reveal();
      }, delay);
      return;
    }

    cancelEmptyStateTimer();

    const token = ++renderToken;

    const cells = await Promise.all(
      items.map(async (item) => {
        const cached = tilesByHandle.get(item.handle);
        if (cached) {
          if (item.sourceCard) rebindRemove(cached, item.sourceCard);
          return { item, wrapper: cached.wrapper, cached: true };
        }

        try {
          const html = await fetchTile(item.handle, item.variantId);
          const wrapper = buildCell(item, html);
          return wrapper ? { item, wrapper, cached: false } : null;
        } catch (error) {
          console.error('[wishlist:page] failed to render tile', item.handle, error);
          return null;
        }
      })
    );

    if (token !== renderToken) return;

    const fragment = document.createDocumentFragment();
    const seen = new Set();

    cells.forEach((cell) => {
      if (!cell) return;
      seen.add(cell.item.handle);
      fragment.appendChild(cell.wrapper);
      if (!cell.cached) {
        tilesByHandle.set(cell.item.handle, {
          wrapper: cell.wrapper,
          sourceCard: cell.item.sourceCard || null,
        });
      }
    });

    tilesByHandle.forEach((cell, handle) => {
      if (!seen.has(handle)) {
        cell.wrapper.remove();
        tilesByHandle.delete(handle);
      }
    });

    items.forEach((item) => {
      pendingRemovalHandles.delete(item.handle);
    });

    if (items.length > 0) {
      grid.replaceChildren(fragment);
      updateEmptyState(items.length);
    } else {
      grid.replaceChildren();
      updateEmptyState(0);
    }

    if (!isSharedView) {
      syncWishlistHints(items);
    }

    reveal();
  };

  const render = async () => {
    if (!hasHydrated) {
      if (!detectHydration()) return;
      hasHydrated = true;
    }
    await renderItems(collectItems());
  };

  let scheduled = null;
  const scheduleRender = () => {
    if (scheduled) return;
    scheduled = requestAnimationFrame(() => {
      scheduled = null;
      render();
    });
  };

  const observer = new MutationObserver(scheduleRender);
  observer.observe(swishHost, { childList: true, subtree: true });
  scheduleRender();

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('wishlist-page').then(() => {
      setTimeout(() => {
        if (revealed) return;
        if (detectHydration()) return;
        hasHydrated = true;
        scheduleRender();
      }, 1500);
    });
  }

  setTimeout(() => {
    if (revealed) return;
    if (detectHydration()) return;
    hasHydrated = true;
    scheduleRender();
  }, 4000);

  body.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('form');
      if (!form || !form.querySelector('[name="id"]')) return;

      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

      event.preventDefault();
      event.stopPropagation();

      const formData = new FormData(form);

      try {
        if (typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((section) => section.id).join(',')
          );
          formData.append('sections_url', window.location.pathname);
        }
      } catch {
        formData.delete('sections');
        formData.delete('sections_url');
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;
          cartDrawer.renderContents(response);
        })
        .catch((error) => {
          console.error('[wishlist] add to cart failed:', error);
        });
    },
    true
  );
})();
